export const EMAIL = 'EMAIL';
export const setEmail = (payload) => ({ type: EMAIL, payload });
export const EXPENSES = 'EXPENSES';
export const setExpenses = (payload) => ({ type: EXPENSES, payload });
